import crud from "@/store/core/crud";
import list from "@/store/core/list";
import action from "@/store/core/action";

import {
  GET_UNIT_CATEGORIES_LIST,
  GET_UNIT_CATEGORIES_LIST_SUCCESS,
  GET_UNIT_CATEGORIES_LIST_FAIL,
  GET_UNIT_CATEGORIES_PAGINATION,
  GET_UNIT_CATEGORIES_PAGINATION_SUCCESS,
  GET_UNIT_CATEGORIES_PAGINATION_FAIL,
  GET_UNIT_CATEGORIES_COLLECTION,
  GET_UNIT_CATEGORIES_COLLECTION_SUCCESS,
  GET_UNIT_CATEGORIES_COLLECTION_FAIL,
  GET_UNIT_CATEGORIES_SINGLE,
  GET_UNIT_CATEGORIES_SINGLE_SUCCESS,
  GET_UNIT_CATEGORIES_SINGLE_FAIL,
  CREATE_UNIT_CATEGORIES,
  CREATE_UNIT_CATEGORIES_SUCCESS,
  CREATE_UNIT_CATEGORIES_FAIL,
  CREATE_UNIT_CATEGORIES_RESET,
  UPDATE_UNIT_CATEGORIES,
  UPDATE_UNIT_CATEGORIES_SUCCESS,
  UPDATE_UNIT_CATEGORIES_FAIL,
  UPDATE_UNIT_CATEGORIES_RESET,
  REMOVE_UNIT_CATEGORIES,
  REMOVE_UNIT_CATEGORIES_SUCCESS,
  REMOVE_UNIT_CATEGORIES_FAIL,
  GET_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG,
  GET_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_SUCCESS,
  GET_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_FAIL,
  UPDATE_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG,
  UPDATE_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_SUCCESS,
  UPDATE_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_FAIL,
  UPDATE_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_RESET,
  PULL_UNIT_CATEGORY_IMAGES,
  PULL_UNIT_CATEGORY_IMAGES_SUCCESS,
  PULL_UNIT_CATEGORY_IMAGES_FAIL,
} from "./actions";

const listProcessed = list.process({
  getListRequest: {
    action: GET_UNIT_CATEGORIES_LIST,
    endPoint: "3.0/unit-categories/list",
    mutationFail: GET_UNIT_CATEGORIES_LIST_FAIL,
    mutationSuccess: GET_UNIT_CATEGORIES_LIST_SUCCESS
  },
});

const crudProcessed = crud.process({
  getPaginationRequest: {
    action: GET_UNIT_CATEGORIES_PAGINATION,
    endPoint: "3.0/unit-categories/paginated",
    mutationFail: GET_UNIT_CATEGORIES_PAGINATION_FAIL,
    mutationSuccess: GET_UNIT_CATEGORIES_PAGINATION_SUCCESS
  },
  getCollectionRequest: {
    action: GET_UNIT_CATEGORIES_COLLECTION,
    endPoint: "3.0/unit-categories/collected",
    mutationFail: GET_UNIT_CATEGORIES_COLLECTION_FAIL,
    mutationSuccess: GET_UNIT_CATEGORIES_COLLECTION_SUCCESS
  },
  getSingleRequest: {
    action: GET_UNIT_CATEGORIES_SINGLE,
    endPoint: "3.0/unit-categories/single",
    mutationFail: GET_UNIT_CATEGORIES_SINGLE_FAIL,
    mutationSuccess: GET_UNIT_CATEGORIES_SINGLE_SUCCESS
  },
  creationRequest: {
    isUpload: true,
    action: CREATE_UNIT_CATEGORIES,
    actionReset: CREATE_UNIT_CATEGORIES_RESET,
    endPoint: "3.0/unit-categories/create",
    mutationFail: CREATE_UNIT_CATEGORIES_FAIL,
    mutationSuccess: CREATE_UNIT_CATEGORIES_SUCCESS
  },
  editingRequest: {
    isUpload: true,
    action: UPDATE_UNIT_CATEGORIES,
    actionReset: UPDATE_UNIT_CATEGORIES_RESET,
    endPoint: "3.0/unit-categories/update",
    mutationFail: UPDATE_UNIT_CATEGORIES_FAIL,
    mutationSuccess: UPDATE_UNIT_CATEGORIES_SUCCESS
  },
  deletionRequest: {
    action: REMOVE_UNIT_CATEGORIES,
    endPoint: "3.0/unit-categories/delete",
    mutationFail: REMOVE_UNIT_CATEGORIES_FAIL,
    mutationSuccess: REMOVE_UNIT_CATEGORIES_SUCCESS
  }
});

const actionsProcessed = action.processMultiple([
  {
    name: 'getUnitCategoryPricePerGuestConfigRequest',
    action: GET_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG,
    endPoint: '3.0/unit-categories/price-per-guest-config/get',
    mutations: {
      fail: GET_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_FAIL,
      success: GET_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_SUCCESS,
    },
  },
  {
    method: 'put',
    name: 'updateUnitCategoryPricePerGuestConfigRequest',
    action: UPDATE_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG,
    actionReset: UPDATE_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_RESET,
    endPoint: '3.0/unit-categories/price-per-guest-config/update',
    mutations: {
      fail: UPDATE_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_FAIL,
      success: UPDATE_UNIT_CATEGORY_PRICE_PER_GUEST_CONFIG_SUCCESS,
    },
  },
  {
    method: 'post',
    name: 'pullUnitCategoryImagesRequest',
    action: PULL_UNIT_CATEGORY_IMAGES,
    endPoint: 'unit-categories/pull-octorate-images/{id}',
    mutations: {
      fail: PULL_UNIT_CATEGORY_IMAGES_FAIL,
      success: PULL_UNIT_CATEGORY_IMAGES_SUCCESS,
    },
  }
]);

const getters = {};

const actions = {
  ...crudProcessed.actions,
  ...listProcessed.actions,
  ...actionsProcessed.actions,
};

const state = {
  ...crudProcessed.state,
  ...listProcessed.state,
  ...actionsProcessed.state,
};

const mutations = {
  ...crudProcessed.mutations,
  ...listProcessed.mutations,
  ...actionsProcessed.mutations,
};

export default {
  state,
  actions,
  mutations,
  getters
};
